/**
 * WebSocket (Socket.IO) bridge for the Hono HTTP layer.
 *
 * Socket.IO attaches to the underlying `http.Server` returned by
 * `@hono/node-server`'s `serve()`. This module is a thin wrapper over the
 * framework-agnostic implementation in `@kernel/events/socket`.
 */

export { initSocketIO, closeSocketIO } from '@kernel/events/socket.js'
export type { SocketIOOptions } from '@kernel/events/socket.js'
